document.addEventListener('click', function (e) {
  var link = e.target.closest('.contact-hotel-chat .cta-link');
  if (!link) return;
  e.preventDefault();
  var hotelAppId = link.dataset.appId;
  if (hotelAppId && typeof triggerLiveChat === 'function') {
    triggerLiveChat(hotelAppId);
  }
});

function simulateMouseClick(targetNode) {
    function triggerMouseEvent(targetNode, eventType) {
        var clickEvent = document.createEvent('MouseEvents');
        clickEvent.initEvent(eventType, true, true);
        targetNode.dispatchEvent(clickEvent);
    }
    ["mouseover", "mousedown", "mouseup", "click"].forEach(function (eventType) {
        triggerMouseEvent(targetNode, eventType);
    });
}

function triggerLiveChat(hotelAppId) {

    ReviewPro.destroy();

    ReviewPro.init({
        appId: hotelAppId,
        customText: {
            conversationTimestampHeaderFormat: 'MMMM D YYYY, h:mm A',
            headerText: 'How can we help?',
            inputPlaceholder: 'Type a message...',
            introAppText: 'Message us below or from your favorite app.',
            introductionText: 'We\'re here to talk, so ask us anything!',
        }
    })
    .then(function () {
        ReviewPro.on("widget:opened", function () {
            ReviewPro.startConversation();

        });
    });

    WaitForReviewProIFrame();

}

var waitCount = 0;
var maxWait = 10;

function WaitForReviewProIFrame() {
    waitCount++;
    if (document.getElementById('web-messenger-container')) {
        var element = document.getElementById('web-messenger-container'); //there it is
        var clickElement = null;
        try { var doc = element.contentDocument || element.contentWindow.document; if (doc) clickElement = doc.querySelector('.messenger-button-icon'); } catch (err) { clickElement = null; }
        if (clickElement) {
            simulateMouseClick(clickElement);
        } else {
            if (waitCount <= maxWait) {
                setTimeout(WaitForReviewProIFrame, 1000);
            }
        }
    } else {
        if (waitCount <= maxWait) {
            setTimeout(WaitForReviewProIFrame, 1000);
        }
    }
}






